module.exports = __webpack_public_path__ + "build/desktop/a/img/roomInfoDg__gallery.3eacd0132310ea44cad756b378a3bc07.gif";